import { render, staticRenderFns } from "./MessageViewModal.vue?vue&type=template&id=48d022f1&"
import script from "./MessageViewModal.vue?vue&type=script&lang=js&"
export * from "./MessageViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports